import React from 'react';

export default function CenterCard({ children }) {
    return (
        <article className='d-flex vw-100 vh-100 justify-content-center align-items-center'>
            { children }
        </article>
    );
}